import { HTMLAttributes, useCallback, useEffect } from 'react';

import { StyledOverlay } from './Overlay.styles';

export const Overlay = ({
  isOpen,
  zIndex,
  ...rest
}: {
  isOpen?: boolean;
  zIndex?: number;
} & HTMLAttributes<HTMLDivElement>) => {
  const makeScrollable = useCallback(() => {
    document.body.style.position = '';
    document.body.style.overflowY = '';
    document.body.style.width = '';
  }, []);

  const makeUnscrollable = useCallback(() => {
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';
  }, []);

  useEffect(() => {
    if (isOpen) {
      makeUnscrollable();
    } else {
      makeScrollable();
    }

    return () => {
      makeScrollable();
    };
  }, [isOpen, makeScrollable, makeUnscrollable]);

  return isOpen ? (
    <StyledOverlay isOpen={isOpen} zIndex={zIndex} {...rest} />
  ) : null;
};
